import MediaPlayerSdk from '@wix/thunderbolt-elements/src/components/VideoBox/corvid/VideoBox.corvid';


const MediaPlayer = {
  sdk: MediaPlayerSdk
};


export const components = {
  ['MediaPlayer']: MediaPlayer
};

